import _slicedToArray from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function oauthAuthorizationUrl(options) {
  var clientType = options.clientType || "oauth-app";
  var baseUrl = options.baseUrl || "https://github.com";
  var result = {
    clientType: clientType,
    allowSignup: options.allowSignup === false ? false : true,
    clientId: options.clientId,
    login: options.login || null,
    redirectUrl: options.redirectUrl || null,
    state: options.state || Math.random().toString(36).substr(2),
    url: ""
  };

  if (clientType === "oauth-app") {
    var scopes = "scopes" in options ? options.scopes : [];
    result.scopes = typeof scopes === "string" ? scopes.split(/[,\s]+/).filter(Boolean) : scopes;
  }

  result.url = urlBuilderAuthorize("".concat(baseUrl, "/login/oauth/authorize"), result);
  return result;
}

function urlBuilderAuthorize(base, options) {
  var map = {
    allowSignup: "allow_signup",
    clientId: "client_id",
    login: "login",
    redirectUrl: "redirect_uri",
    scopes: "scope",
    state: "state"
  };
  var url = base;
  Object.keys(map) // Filter out keys that are null and remove the url key
  .filter(function (k) {
    return options[k] !== null;
  }) // Filter out empty scopes array
  .filter(function (k) {
    if (k !== "scopes") return true;
    if (options.clientType === "github-app") return false;
    return !Array.isArray(options[k]) || options[k].length > 0;
  }) // Map Array with the proper URL parameter names and change the value to a string using template strings
  // @ts-ignore
  .map(function (key) {
    return [map[key], "".concat(options[key])];
  }) // Finally, build the URL
  .forEach(function (_ref, index) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    url += index === 0 ? "?" : "&";
    url += "".concat(key, "=").concat(encodeURIComponent(value));
  });
  return url;
}

export { oauthAuthorizationUrl };